module.exports = "/_next/static/images/OctoDiagram-lg-2deb856e249a7dc51170b8e1f41fcb35.webp";